import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { isNotNull } from '@hcr/utils'

import { useHoliday } from '../../../../contexts'
import { useDestinationDetailsQuery } from '../../../../hooks'
import { useTicketsCount } from '../../../../hooks/common'
import { createTicketsTotalCount } from '../../../../utils'
import { BookingOverviewHeroCard } from '../common'

import { BookingOverviewDestinationHomeLoading } from './BookingOverviewDestinationHomeLoading'

export const BookingOverviewDestinationHome: FC = () => {
  const { t } = useTranslation()
  const holiday = useHoliday()
  const destinationId = holiday.data.destinationId

  const destinationDetails = useDestinationDetailsQuery(
    { destinationId: String(destinationId) },
    { enabled: isNotNull(destinationId) }
  )

  const ticketsCount = useTicketsCount()

  if (holiday.isSuccess && destinationDetails.isSuccess) {
    const resortId = destinationDetails.data.hotelId ?? destinationDetails.data.mokkiId
    const totalTickets = isNotNull(resortId) ? createTicketsTotalCount(ticketsCount, resortId) : 0

    return (
      <BookingOverviewHeroCard
        title={t('booking.no-accommodation-booked')}
        linkLabel={t('home.open')}
        onLinkClick={() => holiday.setDestinationId(destinationDetails.data.destinationId)}
        ticketsCount={ticketsCount}
        totalTickets={totalTickets}
      >
        {destinationDetails.data.name}
      </BookingOverviewHeroCard>
    )
  }

  return <BookingOverviewDestinationHomeLoading />
}
